import { Link } from 'react-router-dom';

import './styles/tier-chip.css';

// Which tier a task belongs to, as a chip.
//
// DUMB ON PURPOSE. It resolves nothing and asks nothing: `common/` may not
// import from `global/` or `features/` (TSS vite/01 [RIGID]), so the label
// comes resolved and the caller decides whether it links — the tier's own
// screen is behind `tiers:write`, and a link that lands on /unauthorized is
// worse than a chip that does not move.

export default function TierChip({ label, title, to }) {
    if (!label) return null;

    if (!to) {
        return <span className="tier-chip" title={title || undefined}>{label}</span>;
    }

    return (
        <Link to={to} className="tier-chip tier-chip--link" title={title || undefined}>
            {label}
        </Link>
    );
}
